import { render, staticRenderFns } from "./loginScreenMobile.vue?vue&type=template&id=27c1484c"
import script from "./loginScreenMobile.vue?vue&type=script&lang=js"
export * from "./loginScreenMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports